import React from "react";
import { SafeArea, Image, InfiniteScroll } from "antd-mobile";
import styles from "./index.module.less";
import { FC, useEffect, useState } from "react";
import { game_rank_title } from "~src/assets/images/answerGame";
import { getWeekRankingList } from "~src/service/answer";
import { RankingListType } from "~src/service/answer/answer";
import {formatTime} from "~src/utils/tool";
import { useNavigate } from "react-router-dom";
import useSendCurrentPagePath from "~src/hooks/useSendCurrentPagePath";

const RankingList: FC = () => {
  const navigate = useNavigate()
  const [rankdata, setRankdata] = useState<RankingListType[]>([])
  const [rank, setRank] = useState<RankingListType>({} as RankingListType)
  const {sendMessage} = useSendCurrentPagePath()
  sendMessage({
    title: "和绿喵一起涨知识，答对4题赢低碳惊喜好礼",
    type: "share",
    path: "",
    shareQuery: "&share=true&type=all",
    selfQuery: "&share=true&type=all"
  })
  const getWeekRankingData = async () => {
    const { rankingList, member } = await getWeekRankingList()
    setRankdata(rankingList || [])
    setRank(member || {})
  }
  useEffect(() => {
    getWeekRankingData()
  }, [])
  return <div>
    <div className={styles.ranking}>
      <div className={styles.py}>
        <div className={styles["py-rule"]} onClick={() => {
          navigate('/answer/publicity')
        }}>获奖公示</div>
        <div className={styles["py-timer"]}>每周日晚22:00截止</div>
        <Image src={game_rank_title} />
      </div>
      {!!rank.order &&
        <div className={styles["ranking-my"]}>
          <div className={styles["ranking-boby-item"]} key={rank.nikeName}>
            <div className={styles["ranking-boby-index"]}>
              {rank.order > 3 ? rank.order: <Image src={require(`../../../assets/images/answerGame/game_rank_${rank.order -1}.png`)}></Image>}
            </div>
            <div className={styles["ranking-boby-info"]}>
              <Image src={rank.avatar}
                fit='cover'
                width={27}
                height={27}
                className={styles["ranking-boby-info-border0"]}
                style={{ borderRadius: 32 }} />
              <div className={styles["ranking-boby-info-name"]} >{rank.nikeName}</div>
            </div>
            <div className={styles["ranking-boby-integral"]}>{rank.point}</div>
            <div className={styles["ranking-boby-timer"]}>
              {formatTime(Number(rank.time), "h-m-s")}
            </div>
          </div>
        </div>
      }

      <div className={styles["ranking-header"]}>
        <div >排名</div>
        <div className={styles["ranking-header-info"]}>姓名</div>
        <div className={styles["ranking-header-integral"]}>累计积分</div>
        <div>闯关总时长</div>
      </div>
      <div className={styles["ranking-boby"]}>
        {
          rankdata?.map((ele: RankingListType, index) => {
            return <div className={styles["ranking-boby-item"]} key={ele.nikeName}>
              <div className={styles["ranking-boby-index"]}>
                {ele.order > 3 ? ele.order : <Image src={require(`../../../assets/images/answerGame/game_rank_${index}.png`)}></Image>}
              </div>
              <div className={styles["ranking-boby-info"]}>
                <Image src={ele.avatar}
                  fit='cover'
                  width={27}
                  height={27}
                  className={styles["ranking-boby-info-border0"]}
                  style={{ borderRadius: 32 }} />
                <div className={styles["ranking-boby-info-name"]} >{ele.nikeName}</div>
              </div>
              <div className={styles["ranking-boby-integral"]}>{ele.point}</div>
              <div className={styles["ranking-boby-timer"]}>
                {formatTime(Number(ele.time), "h-m-s")}
              </div>
            </div>
          })
        }
      </div>
    </div>
    <InfiniteScroll loadMore={async () => void 0} hasMore={false} />
    <SafeArea position="bottom" />
  </div>
}
export default RankingList